(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-l5p-tabs]').forEach((tabs) => {
      if (tabs.dataset.initialized === 'true') return;
      tabs.dataset.initialized = 'true';

      const section = tabs.closest('[data-l5p-uses]');
      if (!section) return;
      const image = section.querySelector('[data-l5p-use-image]');
      const label = section.querySelector('[data-l5p-use-label]');

      tabs.addEventListener('click', (event) => {
        const button = event.target.closest('[data-l5p-tab]');
        if (!button || !tabs.contains(button)) return;

        tabs.querySelectorAll('[data-l5p-tab]').forEach((tab) => {
          const selected = tab === button;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
        });

        if (image && button.dataset.image) {
          image.style.opacity = '.25';
          window.setTimeout(() => {
            image.src = button.dataset.image;
            image.alt = button.dataset.alt || '';
            image.style.opacity = '1';
          }, 140);
        }
        if (label) label.textContent = button.dataset.label || button.textContent.trim();
      });

      tabs.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const buttons = Array.from(tabs.querySelectorAll('[data-l5p-tab]'));
        const current = buttons.indexOf(document.activeElement);
        if (current < 0) return;
        event.preventDefault();
        let next = current;
        if (event.key === 'ArrowLeft') next = (current - 1 + buttons.length) % buttons.length;
        if (event.key === 'ArrowRight') next = (current + 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        buttons[next].focus();
        buttons[next].click();
      });
    });

    const applyVariant = (section, variantId) => {
      const option = Array.from(section.querySelectorAll('[data-l5p-variant-option]'))
        .find((candidate) => candidate.dataset.variantId === variantId);
      if (!option) return;

      const available = option.dataset.variantAvailable === 'true';
      const offerIsActive = section.dataset.proEarlybirdActive === 'true';
      const submit = section.querySelector('[data-l5p-submit]');
      const input = section.querySelector('[data-l5p-variant-input]');
      const shippingCard = section.querySelector('[data-l5p-shipping-card]');

      section.querySelectorAll('[data-l5p-variant-option]').forEach((candidate) => {
        const selected = candidate.dataset.variantId === variantId;
        candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
        candidate.setAttribute('tabindex', selected ? '0' : '-1');
      });
      section.querySelectorAll('[data-l5p-selected-variant]').forEach((label) => {
        label.textContent = option.dataset.variantTitle || '';
      });
      section.querySelectorAll('[data-l5p-regular-price-value]').forEach((price) => {
        price.textContent = option.dataset.variantPrice || '';
      });
      section.querySelectorAll('[data-l5p-offer-price-value]').forEach((price) => {
        price.textContent = option.dataset.variantOfferPrice || '';
      });
      section.querySelectorAll('[data-l5p-availability]').forEach((status) => {
        status.textContent = available ? '' : 'Sold out';
      });
      if (shippingCard) {
        const shippingStatus = shippingCard.querySelector('[data-l5p-shipping-status]');
        const shippingCopy = shippingCard.querySelector('[data-l5p-shipping-copy]');
        const shippingExpected = shippingCard.querySelector('[data-l5p-shipping-expected]');
        const shippingLink = shippingCard.querySelector('[data-l5p-shipping-link]');
        shippingCard.dataset.shippingState = option.dataset.shippingState || 'available';
        if (shippingStatus) shippingStatus.textContent = option.dataset.shippingStatus || '';
        if (shippingCopy) shippingCopy.textContent = option.dataset.shippingCopy || '';
        if (shippingExpected) {
          shippingExpected.textContent = option.dataset.shippingExpected || '';
          shippingExpected.hidden = !option.dataset.shippingExpected;
        }
        if (shippingLink) {
          const retailerUrl = option.dataset.shippingRetailerUrl || '';
          shippingLink.textContent = option.dataset.shippingCtaLabel || 'Shop with a retailer';
          shippingLink.href = retailerUrl || '#';
          shippingLink.hidden = !retailerUrl;
        }
      }

      if (input) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (submit) {
        submit.disabled = !available;
        submit.setAttribute('aria-disabled', available ? 'false' : 'true');
        const label = submit.querySelector('[data-l5p-button-label]');
        if (label) {
          label.textContent = available
            ? (offerIsActive ? submit.dataset.earlybirdLabel : submit.dataset.regularLabel)
            : 'Sold Out';
        }
      }
    };

    const selectVariant = (section, variantId) => {
      const productId = section.dataset.l5pProductId;
      document.querySelectorAll('[data-l5p-product-root]').forEach((candidate) => {
        if (candidate.dataset.l5pProductId === productId) applyVariant(candidate, variantId);
      });
    };

    root.querySelectorAll('[data-l5p-product-root]').forEach((section) => {
      if (section.dataset.l5pVariantInitialized === 'true') return;
      section.dataset.l5pVariantInitialized = 'true';

      section.addEventListener('click', (event) => {
        const option = event.target.closest('[data-l5p-variant-option]');
        if (!option || !section.contains(option)) return;
        selectVariant(section, option.dataset.variantId);
      });

      section.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const options = Array.from(section.querySelectorAll('[data-l5p-variant-option]'));
        const current = options.indexOf(document.activeElement);
        if (current < 0) return;
        event.preventDefault();
        let next = current;
        if (event.key === 'ArrowLeft') next = (current - 1 + options.length) % options.length;
        if (event.key === 'ArrowRight') next = (current + 1) % options.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = options.length - 1;
        options[next].focus();
        options[next].click();
      });

      section.addEventListener('pro:earlybird-change', () => {
        const activeInput = section.querySelector('[data-l5p-variant-input]');
        if (activeInput) applyVariant(section, activeInput.value);
      });

      const input = section.querySelector('[data-l5p-variant-input]');
      if (input) applyVariant(section, input.value);
    });

    root.querySelectorAll('[data-l5p-video-dialog]').forEach((dialog) => {
      if (dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';

      const section = dialog.closest('.l5p--product');
      const opener = section && section.querySelector(`[aria-controls="${dialog.id}"]`);
      const closeButton = dialog.querySelector('[data-l5p-video-close]');
      const hostedVideo = dialog.querySelector('video');
      const externalVideo = dialog.querySelector('[data-l5p-video-embed]');
      const externalVideoSrc = externalVideo && externalVideo.src;
      let returnFocus = null;

      const stopVideo = () => {
        if (hostedVideo) hostedVideo.pause();
        if (externalVideo && externalVideoSrc) {
          externalVideo.src = 'about:blank';
          externalVideo.src = externalVideoSrc;
        }
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          stopVideo();
          if (returnFocus) returnFocus.focus();
          returnFocus = null;
        }
      };

      if (opener) {
        opener.addEventListener('click', () => {
          returnFocus = opener;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          window.requestAnimationFrame(() => closeButton && closeButton.focus());
        });
      }

      if (closeButton) closeButton.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', () => {
        stopVideo();
        if (returnFocus) returnFocus.focus();
        returnFocus = null;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
